<!--<a [routerLink]="[routerService.homePageUrl]">-->
<!--  <img [src]="'assets/images/logo.svg'"-->
<!--       alt="Biletix"-->
<!--       class="logo">-->
<!--</a>-->

<!--TODO: Seam projesi aradan çıkarıldıktan sonra yukarıdaki link aktif edilecek.-->
<a [href]="routerService.getSeamHomePageUrl()">
  <img [src]="logoPath" alt="Biletix" class="logo">
</a>